// extracted by mini-css-extract-plugin
export default {"btn_zamknij":"DodajOddanieBrakBtn_btn_zamknij__jqAa9"};